import { FroalaEditorFunctionality } from './FroalaEditorFunctionality';
import * as React from 'react';

export class FroalaEditorInput extends FroalaEditorFunctionality {    
  render () {
    const that: any = this 
    return (
      <input ref={el => that.el = el}/>
    );
  }
}